var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('h3',[_vm._v(" "+_vm._s(_vm.title))]),_c('div',{staticClass:"spliter"}),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }